(() => {
  const section = document.querySelector('[data-dg-softener-bulk]');
  const picker = section?.querySelector('[data-dg-softener-bulk-picker]');
  const button = section?.querySelector('[data-dg-softener-bulk-submit]');
  const price = button?.querySelector('[data-dg-softener-bulk-price]');
  if (!picker || !button?.form || !price) return;

  function selectedQuantity() {
    return picker.querySelector('input:checked');
  }

  const priceRoot = section.querySelector(`#price-${section.dataset.section}`);

  function render() {
    const selectedPrice = selectedQuantity().closest('label').querySelector('.dg-bundle-row__prices strong');
    price.replaceChildren(...Array.from(selectedPrice.childNodes, (node) => node.cloneNode(true)));
    price.hidden = false;
    if (priceRoot && selectedPrice.dataset.offerCents) {
      priceRoot.dataset.dgInstallmentTotal = selectedPrice.dataset.offerCents;
    }
  }

  picker.addEventListener('change', render);
  button.form.addEventListener('formdata', ({ formData }) => {
    formData.set('quantity', selectedQuantity().value);
  });
  render();
  section.setAttribute('data-dg-softener-bulk-ready', '');
  picker.hidden = false;
})();
